"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = require("./colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var isSelectionTruthy = function isSelectionTruthy(value) {
  return !(Array.isArray(value) && !value.length || value === null || value === undefined || value === '');
};

var noop = function noop() {};

var SelectWrapper = function SelectWrapper(props) {
  var value = props.value,
      containerClassName = props.containerClassName,
      placeholder = props.placeholder,
      label = props.label,
      selectedSelect = props.selectedSelect,
      required = props.required,
      helpText = props.helpText,
      onBlurResetsInput = props.onBlurResetsInput,
      _props$onBlur = props.onBlur,
      onBlur = _props$onBlur === void 0 ? noop : _props$onBlur,
      _props$onFocus = props.onFocus,
      onFocus = _props$onFocus === void 0 ? noop : _props$onFocus;

  var _useState = (0, _react.useState)(value),
      _useState2 = _slicedToArray(_useState, 2),
      shouldFloat = _useState2[0],
      setShouldFloat = _useState2[1];

  var handleFocus = function handleFocus() {
    setShouldFloat(true);
    onFocus();
  };

  var handleBlur = function handleBlur(_ref) {
    var target = _ref.target;

    if (onBlurResetsInput === false && target.value || isSelectionTruthy(value)) {
      setShouldFloat(true);
    } else {
      setShouldFloat(false);
    }

    onBlur();
  };

  var handleInputKeyDown = function handleInputKeyDown() {
    setShouldFloat(true);
  };

  (0, _react.useEffect)(function () {
    setShouldFloat(isSelectionTruthy(value));
  }, [value]);
  var className = "react-select-wrapper form-group ".concat(shouldFloat ? 'form-group-active' : '', " ").concat(containerClassName || '');
  return _react["default"].createElement("div", {
    className: className
  }, _react["default"].createElement("label", {
    style: {
      pointerEvents: 'none',
      wordWrap: 'break-word',
      width: '80%'
    },
    className: "control-label"
  }, placeholder || label, required ? _react["default"].createElement("span", {
    style: {
      color: _colors.persimmon.base
    }
  }, " *") : ''), _react["default"].createElement(selectedSelect, _objectSpread({}, props, {
    onFocus: handleFocus,
    onBlur: handleBlur,
    onInputKeyDown: handleInputKeyDown,
    placeholder: ''
  })), helpText ? _react["default"].createElement("small", {
    className: "help-block"
  }, helpText) : null);
};

SelectWrapper.propTypes = {
  containerClassName: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  selectedSelect: _propTypes["default"].func,
  label: _propTypes["default"].node,
  placeholder: _propTypes["default"].node,
  value: _propTypes["default"].any,
  // eslint-disable-line react/forbid-prop-types
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  helpText: _propTypes["default"].node,
  onBlurResetsInput: _propTypes["default"].bool
};
var _default = SelectWrapper;
exports["default"] = _default;